import { Col, Row } from 'antd';
import styled from 'styled-components';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';

const StyleWrapper = styled.div`
  margin: 21px 0;
`;

const TopPeopleAndCompaniesFullSkeleton = function TopPeopleAndCompaniesFullSkeleton() {
  return (
    <StyleWrapper id="tabs-target">
      <Row gutter={16}>
        <Col span={15} xs={24} sm={15}>
          <div>
            <SkeletonCustom height="20px" width="200px" margin="0px 0px 10px 0px" />
            <Row gutter={[5, 5]} className="resolution-fix top-companies">
              <SkeletonCustom width="140px" height="90px" margin="0px 10px 10px 5px" />
              <SkeletonCustom width="140px" height="90px" margin="0px 10px 10px 5px" />
              <SkeletonCustom width="140px" height="90px" margin="0px 10px 10px 5px" />
              <SkeletonCustom width="140px" height="90px" margin="0px 10px 10px 5px" />
            </Row>
          </div>
        </Col>
        <Col span={9} xs={24} sm={9}>
          <div>
            <SkeletonCustom height="20px" width="200px" margin="0px 0px 10px 0px" marginSm="20px 0px 0px 0px" />
            <Row gutter={[5, 5]} className="resolution-fix top-people">
              <SkeletonCustom width="90px" height="90px" diameter="50%" />
              <SkeletonCustom width="90px" height="90px" diameter="50%" />
              <SkeletonCustom width="90px" height="90px" diameter="50%" />
              <SkeletonCustom width="90px" height="90px" diameter="50%" />
            </Row>
          </div>
        </Col>
      </Row>
    </StyleWrapper>
  );
};

export default TopPeopleAndCompaniesFullSkeleton;
